import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';

export const Headline = styled.h5`
  margin: 0 0 ${token('space.150', '12px')} 0;
`;
